import * as React from 'react'

import { Box, CheckBox, Icon, Text } from '@factorialco/deprecated-design-system'

import type LegalEntity from 'modules/core/store/models/LegalEntity'

interface LegalEntityProps {
  selected: boolean
  legalEntity: LegalEntity
}
interface LegalEntityProfileProps {
  legalEntity: LegalEntity
}

const LegalEntityProfile = ({ legalEntity }: LegalEntityProfileProps) => {
  return (
    <Box alignItems="center" flexDirection="row" flexGrow gap="s12">
      <Box flexDirection="row" justifyContent="spaceBetween" width="full">
        <Box>
          <Text.Normal weight="medium" ellipsis>
            {legalEntity.name}
          </Text.Normal>
        </Box>
      </Box>
    </Box>
  )
}

const SingleSelectLegalEntity = ({ legalEntity, selected }: LegalEntityProps) => {
  return (
    <Box
      alignItems="center"
      background={selected ? 'grey200' : 'grey000White'}
      cursor="pointer"
      flexDirection="row"
      gap="s16"
      paddingX="s16"
      paddingY="s12"
      width="full"
    >
      <LegalEntityProfile legalEntity={legalEntity} />
      {selected && (
        <Box>
          <Icon.Medium icon="check" />
        </Box>
      )}
    </Box>
  )
}

const MultiSelectLegalEntity = ({ legalEntity, selected }: LegalEntityProps) => {
  return (
    <Box
      alignItems="center"
      background="grey000White"
      cursor="pointer"
      flexDirection="row"
      gap="s16"
      paddingX="s16"
      paddingY="s12"
      width="full"
    >
      <Box>
        <CheckBox checked={selected} />
      </Box>
      <LegalEntityProfile legalEntity={legalEntity} />
    </Box>
  )
}

interface Props {
  legalEntity: LegalEntity
  selected: boolean
  onSelectLegalEntity: (...args: any[]) => any
  onSelectMultiple?: (() => void) | null
}

export default function Item({
  legalEntity,
  selected,
  onSelectLegalEntity,
  onSelectMultiple,
}: Props) {
  const _LegalEntityComponent = onSelectMultiple ? (
    <MultiSelectLegalEntity legalEntity={legalEntity} selected={selected} />
  ) : (
    <SingleSelectLegalEntity legalEntity={legalEntity} selected={selected} />
  )

  return (
    <Box onClick={onSelectLegalEntity(legalEntity)} width="full">
      {_LegalEntityComponent}
    </Box>
  )
}
